import { useRouter } from 'next/router'

import cn from 'classnames'

import { Crumbs } from 'context/breadcrumbs'

import Text from '../text'
import css from './index.module.scss'

export type BreadcrumbsProps = {
  items: Crumbs[]
}
export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const router = useRouter()
  return (
    <div className={css.container}>
      {items.map((item, index) => {
        const isLastOne = index === items.length - 1
        return (
          <div key={`${item.text}${index}`}>
            {isLastOne ? (
              <Text className={cn(css.breadcrumb, css.lastBreadcrumb)}>{item.text}</Text>
            ) : (
              <div className={css.breadcrumbWrapper}>
                <div
                  onClick={() => {
                    void router.push(item.href)
                  }}
                  className={css.breadcrumb}
                  data-test-id="breadcrumb-link"
                >
                  {item.text}
                </div>

                <span className={css.divider}>/</span>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
